import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledWrapper = styled.div`
  padding: 5px 24px 16px;
  border-width: 1px;
  border-style: solid;
  border-color: ${themeGet('colors.text.border')};
  border-radius: 6px;

  &:not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const StyledText = styled.div`
  color: ${themeGet('colors.text.default')};
  font-size: ${themeGet('fontSizes.xs')}px;

  &:not(:last-child) {
    margin-bottom: 27px;
  }
`;

export const StyledTopHeading = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 5px;
  }

  svg {
    margin-right: 10px;
  }
`;

export const StyledTitle = styled.h5`
  text-transform: uppercase;
`;
